import React from "react";
import SignIn from "./pages/authentication/sign-in";
import SignUp from "./pages/authentication/sign-up";
import RoomType from "./pages/roomType";
import AddRoomType from "./pages/roomType/AddRoomType";
import EditRoomType from "./pages/roomType/EditRoomType";
import EditFaq from "./pages/faq/EditFaq";
import AddFaq from "./pages/faq/AddFaq";
import Faq from "./pages/faq";
import Room from "./pages/room";
import { Navigate, Route, Routes } from "react-router-dom";
import AddRoom from "./pages/room/AddRoom";
import EditRoom from "./pages/room/EditRoom";
import Dashboard from "./pages/dashboard";
import EditArticle from "./pages/article/EditArticle";
import AddArticle from "./pages/article/AddArticle";
import Article from "./pages/article";
import Career from "./pages/career";
import AddCareer from "./pages/career/AddCareer";
import EditCareer from "./pages/career/EditCareer";
import AddSpecialOffer from "./pages/specialOffers/AddSpecialOffers";
import EditSpecialOffer from "./pages/specialOffers/EditSpecialOffers";
import SpecialOffer from "./pages/specialOffers";
import AddAmenity from "./pages/amenity/AddAmenity";
import EditAmenity from "./pages/amenity/EditAmenity";
import Amenity from "./pages/amenity";
import AddOurService from "./pages/ourServices/AddOurServices";
import EditOurService from "./pages/ourServices/EditOurServices";
import OurService from "./pages/ourServices";
import ContactUs from "./pages/contactUs";
import UserTable from "./pages/user";
import { useDispatch } from "react-redux";
import ManageHomeSection from "./pages/homeSection";
import ManageAboutUs from "./pages/aboutusSection";
import ManageDinning from "./pages/dinning";
import Testimonials from "./pages/testimonials";
import { FaUserGroup } from "react-icons/fa6";
import { FaAcquisitionsIncorporated, FaBlog, FaHome, FaHotel, FaProductHunt, FaQuestionCircle, FaServicestack, FaSurprise, FaUniversity, FaUser } from "react-icons/fa";
import ManageFooterSection from "./pages/footer";
import ManageGallerySection from "./pages/gallery";
import ManageMeetingEvent from "./pages/meetingEvent";
import MenuAccess from "./pages/menuAccess";
import { TiThMenu } from "react-icons/ti";
import { RiGalleryFill } from "react-icons/ri";
import AddTestimonial from "./pages/testimonials/AddTestimonials";
import { GiNailedFoot } from "react-icons/gi";
import AddLanguage from "./pages/language/AddLanguge";
import EditLanguage from "./pages/language/EditLanguge";
import Language from "./pages/language";

import DashboardIcon from '@mui/icons-material/Dashboard';
import LanguageIcon from '@mui/icons-material/Language';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import CollectionsIcon from '@mui/icons-material/Collections';
import WidgetsIcon from '@mui/icons-material/Widgets';
// Soft UI Dashboard React layouts
// import Dashboard from "layouts/dashboard";
// import Tables from "layouts/tables";
// import Billing from "layouts/billing";
// import VirtualReality from "layouts/virtual-reality";
// import RTL from "layouts/rtl";
// import Profile from "layouts/profile";
// import SignIn from "layouts/authentication/sign-in";
// import SignUp from "layouts/authentication/sign-up";

// Soft UI Dashboard React icons
// import Shop from "examples/Icons/Shop";
// import Office from "examples/Icons/Office";
// import Settings from "examples/Icons/Settings";
// import Document from "examples/Icons/Document";
// import SpaceShip from "examples/Icons/SpaceShip";
// import CustomerSupport from "examples/Icons/CustomerSupport";
// import CreditCard from "examples/Icons/CreditCard";
// import Cube from "examples/Icons/Cube";

// Define a type for individual route itemsinterface Route {
  interface Route {
    type: string;
    name: string;
    key: string;
    route: string;
    component: JSX.Element;
    noCollapse: boolean;
    icon?: JSX.Element;  // Add the icon property as optional
    onClick?: () => void; // If you need an onClick function
    title?: string;  // In case you want to add a title property as well
  }
// const dispatch = useDispatch();


// Define the routes array with type annotations
const navRoutes: Route[] = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <DashboardIcon />,
    component: <Dashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Languages",
    key: "languages",
    route: "/languages",
    icon: <LanguageIcon  />,
    component: <Language />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   route: "/",
  //   icon: <FaAcquisitionsIncorporated size="12px" />,
  //   component: <Dashboard />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Room Type",
  //   key: "room-type",
  //   route: "/room-type",
  //   icon: <FaHotel size="12px" />,
  //   component: <RoomType />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Faq",
  //   key: "faq",
  //   route: "/faq",
  //   icon: <FaQuestionCircle size="12px" />,
  //   component: <Faq />,
  //   noCollapse: true,
  // },

  // {
  //   type: "collapse",
  //   name: "Room",
  //   key: "room",
  //   route: "/room",
  //   icon: <FaHotel size="12px" />,
  //   component: <Room />,
  //   noCollapse: true,
  // },

  // {
  //   type: "collapse",
  //   name: "Article",
  //   key: "article",
  //   route: "/article",
  //   icon: <FaBlog size="12px" />,
  //   component: <Article />,
  //   noCollapse: true,
  // },

  // {
  //   type: "collapse",
  //   name: "Career",
  //   key: "career",
  //   route: "/career",
  //   icon: <FaUniversity size="12px" />,
  //   component: <Career />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Special Offer",
  //   key: "specialoffer",
  //   route: "/special-offer",
  //   icon: <FaSurprise size="12px" />,
  //   component: <SpecialOffer />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Contact Inquiries",
    key: "conatct-us",
    route: "/conatct-us",
    icon: <ContactPageIcon  />,
    component: <ContactUs />,
    noCollapse: true,
  },

  // {
  //   type: "collapse",
  //   name: "Our Service",
  //   key: "our-service",
  //   route: "/our-service",
  //   icon: <FaServicestack size="12px" />,
  //   component: <OurService />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Amenity",
  //   key: "amenity",
  //   route: "/amenity",
  //   icon: <FaProductHunt size="12px" />,
  //   component: <Amenity />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "User",
  //   key: "user",
  //   route: "/user",
  //   icon: <FaUser size="12px" />,
  //   component: <UserTable />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Home Sections",
  //   key: "home-section",
  //   route: "/home-section",
  //   icon: <FaHome size="12px" />,
  //   component: <ManageHomeSection />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "About Sections",
  //   key: "about-section",
  //   route: "/about-section",
  //   icon: <FaUser size="12px" />,
  //   component: <ManageAboutUs />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Dinning Sections",
  //   key: "dinning-section",
  //   route: "/dinning-section",
  //   icon: <FaHotel size="12px" />,
  //   component: <ManageDinning />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Testimonials",
  //   key: "testimonials",
  //   route: "/testimonials",
  //   icon: <FaUserGroup size="12px" />,
  //   component: <Testimonials />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",

  //   name: "Footer Sections",
  //   key: "footer-section",
  //   route: "/footer-section",
  //   icon: <GiNailedFoot />,
  //   // @ts-ignore 

  //   component: <ManageFooterSection />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Gallery Sections",
    key: "gallery-section",
    route: "/gallery-section",
    icon: <CollectionsIcon />,
    // @ts-ignore 

    component: <ManageGallerySection />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Meeting & Event",
  //   key: "meeting-event",
  //   route: "/meeting-event",
  //   icon: <FaUserGroup size="12px" />,
  //   component: <ManageMeetingEvent />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Menu Access",
    key: "menu-access",
    route: "/menu-access",
    icon: <WidgetsIcon  />,
    component: <MenuAccess />,
    noCollapse: true,
  },

  
  // {
  //   type: "title",
  //   title: "Account Pages",
  //   key: "account-pages",
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   route: "/profile",
  //   // icon: <CustomerSupport size="12px" />,
  //   // component: <Profile />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign In",
  //   key: "sign-in",
  //   route: "/authentication/sign-in",
  //   // icon: <Document size="12px" />,
  // // @ts-ignore 

  //   component: <SignIn />,
  //   noCollapse: true,
  // },

  // {
  //   type: "collapse",
  //   name: "Logout",
  //   key: "logout",
  //   // icon: <SpaceShip size="12px" />,
  // // @ts-ignore 

  //   noCollapse: true,
  //   onClick: () => {
  //     // Access the dispatch function
  //     dispatch(logout()); // Dispatch the logout action
  //     // Optionally, redirect to the login page or show a toast message
  //   }
  // }


];

//        const mainRoutes = (
//   <Routes>
//     {navRoutes
//       .filter((route) => route.route && route.component)
//       .map((route) => (
//         <Route
//           key={route.key}
//           path={route.route as string}
//           element={route.component}
//         />
//       ))}
//     <Route path="*" element={<Navigate to="/dashboard" />} />
//     <Route path="/faq/edit/:id" element={<EditFaq />} />
//     <Route path="/faq/add" element={<AddFaq />} />
//     <Route path="/room-type/edit/:id" element={<EditRoomType />} />
//     <Route path="/room-type/add" element={<AddRoomType />} />
//     <Route path="/room/add" element={<AddRoom />} />
//     <Route path="/room/edit/:id" element={<EditRoom />} />
//   </Routes>
// );
const mainRoutes = [
  { route: "/faq/edit/:id", component: <EditFaq /> ,key:1},
  { route: "/faq/add", component: <AddFaq /> ,key:2},
  { route: "/room-type/edit/:id", component: <EditRoomType /> ,key:3},
  { route: "/room-type/add", component: <AddRoomType /> ,key:4},
  { route: "/room/add", component: <AddRoom /> ,key:5 },
  { route: "/room/edit/:id", component: <EditRoom /> ,key:6},
  { route: "/article/edit/:id", component: <EditArticle /> ,key:7},
  { route: "/article/add", component: <AddArticle /> ,key:8},
  { route: "/career/add", component: <AddCareer /> ,key:9},
  { route: "/career/edit/:id", component: <EditCareer /> ,key:10},
  { route: "/special-offer/add", component: <AddSpecialOffer /> ,key:11},
  { route: "/special-offer/edit/:id", component: <EditSpecialOffer /> ,key:12},
  { route: "/amenity/add", component: <AddAmenity /> ,key:13},
  { route: "/amenity/edit/:id", component: <EditAmenity /> ,key:14},
  { route: "/our-service/add", component: <AddOurService /> ,key:15},
  { route: "/our-service/edit/:id", component: <EditOurService /> ,key:16},
  { route: "/testimonials/add", component: <AddTestimonial /> ,key:17},
  { route: "/languages/add", component: <AddLanguage /> ,key:17},
  { route: "/languages/edit/:id", component: <EditLanguage /> ,key:17},




];
export { navRoutes, mainRoutes };
